import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconArrowRight({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `edu-icon edu-icon--${size} ${className}`;
  return <>{!!srText && <span className='sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" d="M17.453 9.64q0 .422-.305.72l-5.132 5.117q-.305.304-.68.304-.43 0-.695-.265a.9.9 0 0 1-.266-.657q0-.219.078-.39.086-.172.219-.305l1.75-1.766 2.773-2.53.36.585-2.844.164H3.492q-.445 0-.719-.265-.273-.274-.273-.711 0-.43.273-.696.274-.273.72-.273h9.218l2.844.156-.36.602-2.773-2.547-1.75-1.766a1.2 1.2 0 0 1-.219-.304 1 1 0 0 1-.078-.391q0-.391.266-.656.265-.266.695-.266.18 0 .351.078.18.07.344.235l5.117 5.109a.97.97 0 0 1 .305.719" /></svg></>;
}
export default IconArrowRight;